import moment from 'moment';
import strings from '../../../globalization/index';
const getFormData = () => {
  return {
    left: [
      {
        elementType: 'text',
        inputType: 'alphabets',
        label: strings.ownerNameField,
        placeholder: strings.ownerNamePlaceholder,
        required: true,
        stateField: 'name',
        stateDefault: null,
        minLength: 5,
        maxLength: 128,
      },
      {
        elementType: 'phone',
        keyboardType: 'number-pad',
        inputType: 'phone',
        label: strings.ownerPhoneNumberField,
        placeholder: strings.ownerPhoneNumberPlaceholder,
        required: true,
        stateField: 'phoneNumber',
        stateDefault: '',
        maxLength: 10,
        verifyOtp: true,
      },
      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.vehicleRCField,
        placeholder: strings.vehiceRCPlaceholder,
        required: true,
        stateField: 'vehicleRC',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],

        // allowedFormats: [DocumentPicker.types.pdf, DocumentPicker.types.images],
        maxFiles: 1,
      },
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'alphanumeric',
        label: strings.vehicleInsuranceNumberField,
        placeholder: strings.vehicleInsuranceNumberPlaceholder,
        required: true,
        stateField: 'vehicleInsuranceNumber',
        stateDefault: null,

        maxLength: 20,
        minLength: 10,
        uppercase: true,
      },
      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.vehicleInsuranceValidity,
        placeholder: strings.selectDate,
        required: true,
        stateField: 'vehicleInsuranceValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
      },
      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.PUCCertificateField,
        placeholder: strings.PUCCertificatePlaceholder,
        required: true,
        stateField: 'PUCCertificate',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],
        // allowedFormats: [DocumentPicker.types.pdf, DocumentPicker.types.images],

        maxFiles: 1,
      },
      {
        elementType: 'dropdown',
        inputType: 'text',
        label: strings.vehicleCategory,
        placeholder: strings.enterVehicleCategory,
        optionsField: 'vehicleCategories',
        required: true,
        stateField: 'vehicleCategory',
        stateDefault: null,
        maxLength: 20,
      },
      // {
      //   elementType: 'text',
      //   keyboardType: 'default',
      //   inputType: 'text',
      //   label: strings.vehicleTypeField,
      //   placeholder: strings.vehicleTypePlaceholder,
      //   required: true,
      //   stateField: 'vehicleType',
      //   stateDefault: null,
      //   maxLength: 20,
      // },
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'alphanumeric',
        label: strings.vehicleEngineNumberField,
        placeholder: strings.vehicleEngineNumberPlaceholder,
        required: true,
        stateField: 'vehicleEngineNumber',
        stateDefault: null,
        maxLength: 20,
        minLength: 5,
        uppercase: true,
      },
      {
        elementType: 'text',
        keyboardType: 'number-pad',
        inputType: 'year',
        label: strings.vehicleManufacturingYearField,
        placeholder: strings.vehicleManufacturingYearPlaceholder,
        required: true,
        stateField: 'vehicleManufacturingYear',
        id: 'vehicleManufacturingYear',
        stateDefault: null,
        maxLength: 4,
        minLength: 4,
      },
      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.fitnessCertificateField,
        placeholder: strings.fitnessCertificatePlaceholder,
        required: true,
        stateField: 'fitnessCertificate',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],
        // allowedFormats: [DocumentPicker.types.pdf],

        maxFiles: 1,
      },
      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.officialContractDocument,
        placeholder: strings.selectDocument,
        required: false,
        stateField: 'officialContractDocument',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],
        maxFiles: 1,
      },

      {
        elementType: 'text',
        inputType: 'alphanumeric',
        label: `GST Number`,
        placeholder: `Enter GST Number`,
        required: false,
        stateField: 'GSTNumber',
        stateDefault: '',
        minLength: 10,
        maxLength: 15,
        dependentOnOtherFields: false,
      },
    ],
    right: [
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'email',
        label: strings.ownerEmailField,
        placeholder: strings.ownerEmailPlacholder,
        required: true,
        stateField: 'emailAddress',
        stateDefault: null,
        maxLength: 128,
      },
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'alphanumeric',
        label: strings.vehicleRegistrationNumberField,
        placeholder: strings.vehicleRegistrationPlaceholder,
        required: true,
        stateField: 'vehicleRegistrationNumber',
        stateDefault: null,
        maxLength: 10,
        minLength: 9,
        uppercase: true,
      },
      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.vehicleRCValidity,
        placeholder: strings.selectDate,
        required: true,
        stateField: 'vehicleRCValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
      },
      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.vehicleInsuranceCertificateField,
        placeholder: strings.vehicleInsuranceCertificatePlaceholder,
        required: true,
        stateField: 'vehicleInsuranceCertificate',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],
        // allowedFormats: [DocumentPicker.types.pdf, DocumentPicker.types.images],

        maxFiles: 1,
      },
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'alphanumeric',
        label: strings.vehiclePollutionNumberField,
        placeholder: strings.vehiclePollutionNumberPlaceholder,
        required: true,
        stateField: 'vehiclePollutionNumber',
        stateDefault: null,
        maxLength: 20,
        minLength: 4,
        uppercase: true,
      },

      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.pucValidity,
        placeholder: strings.selectDate,
        required: true,
        stateField: 'pucValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
      },
      {
        elementType: 'dropdown',
        inputType: 'text',
        label: strings.vehicleType,
        placeholder: strings.vehicleTypePlaceholder,
        optionsField: 'vehicleTypeOptions',
        required: true,
        stateField: 'vehicleType',
        stateDefault: null,
        maxLength: 20,
        noOptionsText: 'Please select vehicle category',
      },
      {
        elementType: 'dropdown',
        inputType: 'dropdown',
        label: strings.department,
        placeholder: strings.selectDepartment,
        optionsField: 'deptOptions',
        required: true,
        stateField: 'departmentId',
        stateDefault: null,
        maxLength: 50,
        noOptionsText: 'Please select department',
      },
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'alphanumeric',
        label: strings.vehicleChassisNumberField,
        placeholder: strings.vehicleChassisNumberPlaceholder,
        required: true,
        stateField: 'vehicleChassisNumber',
        stateDefault: null,
        maxLength: 20,
        minLength: 5,
        uppercase: true,
      },
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'text',
        label: strings.vehicleMakeAndModelField,
        placeholder: strings.vehicleMakeAndModelPlaceholder,
        required: true,
        stateField: 'vehicleMakeAndModel',
        id: 'vehicleMakeAndModel',
        stateDefault: null,
        maxLength: 20,
        uppercase: true,
      },
      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.officialContractDocumentValidity,
        placeholder: strings.selectDate,
        required: false,
        stateField: 'officialContractDocumentValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
      },
      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.fitnessCertificateValidity,
        placeholder: strings.selectDate,
        required: true,
        stateField: 'fitnessCertificateValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
      },

      // {
      //   elementType: "text",
      //   keyboardType: "default",
      //   inputType: "alphanumeric",
      //   label: strings.vehicleNumberField,
      //   placeholder: strings.vehicleNumberPlaceholder,
      //   required: true,
      //   stateField: "vehicleNumber",
      //   stateDefault: null,
      //   maxLength: 10,
      // },
    ],
  };
};

export const termsData = [
  {
    title: 'DEFINITIONS',
    content: '"Agreement" shall mean the terms and conditions of use.',
  },
  {
    title: '',
    content:
      '"Application" shall mean the application [e-Drishti] supplied by the Company and downloaded and installed by you on your mobile device, tablet, laptop, computer, etc.',
  },
  {
    title: '',
    content:
      '"Company", "we", "our" and "us" shall mean-- KR mroads India Pvt. Ltd.',
  },
  {
    title: '',
    content:
      '"You" shall mean You, the User of the Website/ Application and "Yourself" interpreted accordingly. ',
  },
  {
    title: '',
    content:
      '"Users" means the Users of the Website/ application collectively and/or individually as the context allows.',
  },
  {
    title: 'Acknowledgement',
    content:
      'Visitors to this website- www.sanya.ai/edrishti are bound by the following terms and conditions ("terms").',
  },
  {
    title: '',
    content:
      'If you do not agree with any of these terms, please do not proceed further with using the site.',
  },
  {
    title: '',
    content:
      'Your access to and use of the services in this website is also conditioned on your acceptance of and compliance with the privacy policy of the website.',
  },
  {
    title: '',
    content:
      'As a precondition to your use of the Services, you represent and warrant that:',
  },
  {
    title: '',
    content: 'The information you provide is accurate and complete.',
  },
  {
    title: '',
    content:
      'The Company (KR mroads India Pvt. Ltd.) is entitled, at all times, to verify the information that you have provided and to refuse the Services or use of the Application without providing any reasons whatsoever.',
  },
  {
    title: '',
    content:
      'You will only use our Services using authorized means. You are responsible to check and ensure you download the correct Application for your device. We will not be liable if you do not have a compatible device or if you download the wrong version of the Application for your device. The Company reserves the right to terminate.',
  },
  {
    title: '',
    content:
      'You specifically authorize us to use, store or otherwise process your data or information (in order to provide the Services to you.)',
  },
  {
    title: '',
    content:
      'You will obey all applicable laws related to the matters set forth herein, and will be solely responsible for any violations of the same.',
  },
  {
    title: '',
    content:
      'You agree that the information or data you provide in the form will or may be subjected to additional scrutiny or validation to prove authenticity. ',
  },
  {
    title: '',
    content:
      'You agree that upon agreement of the form, you will be redirected to the payment gateway and No Refunds will be given except in the event of non-performance or inexplicable errors by/from/of any service by www.sanya.ai/edrishti ',
  },
  {
    title: '',
    content:
      'You agree to receive recurring SMS/Email messages with service-related messages, including updates, alerts, and information.',
  },
];
export { getFormData };
